/**
 * 通用的帮助类
 * vux中有很多的帮助类，也可以直接使用
 * https://vux.li/#/zh-CN/README?id=%E5%B7%A5%E5%85%B7%E5%BA%93
 *
 * @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
 * @link
 * @create 2018-03-15
 */

// import {
//   debug
// } from './../../config/base'

import conf from './../../config/base.js';
import regexpValid from './regexp.js';
import { wechatAppid } from './const';
import { dateFormat } from 'vux';
import vue from 'vue'

import {
  invoiceCheckStatus,
  invoiceReimbursementStatus,
  discernStatus,
} from "./const";

var chars = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];
export function generateMixed(n) {
  var res = '';
  for (var i = 0; i < n; i++) {
    var id = Math.ceil(Math.random() * 35);
    res += chars[id];
  }
  return res;
}

/**
 * 生成UUID
 *
 * @returns
 */
export function generateUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * 设置token
 * @param {any} token
 */
export function setToken(token) {
  if (____isAppH5Browser()) {
    localStorage.setItem('invoiceAssistantMobileAuthInfoH5', token);
  } else if (____isAlipayBrowser()) {
    localStorage.setItem('invoiceAssistantMobileAuthInfoAlipay', token);
  }else if (____isWechatBrowser()) {
    localStorage.setItem('invoiceAssistantMobileAuthInfoWechat', token);
  }else if (____isDingBrowser()) {
    localStorage.setItem('invoiceAssistantMobileAuthInfoDing', token);
  } else {
    localStorage.setItem('invoiceAssistantMobileAuthInfoOther', token);
  }
  // localStorage.setItem('invoiceAssistantMobileAuthInfo', token);
}


export function isExistNotDingToken() {
  if(localStorage.getItem('invoiceAssistantMobileUserSettingH5') || localStorage.getItem('invoiceAssistantMobileUserSettingAlipay') || localStorage.getItem('invoiceAssistantMobileUserSettingWechat')) {
    return true;
  }
  return false;
}

/**
 * 获取存储在 sessionStorage 中的token
 * @returns
 */
export function getToken() {
  // return localStorage.getItem('invoiceAssistantMobileAuthInfo');
  var token = '';
  if (____isAppH5Browser()) {
    token = localStorage.getItem('invoiceAssistantMobileAuthInfoH5');
  } else if (____isAlipayBrowser()) {
    token = localStorage.getItem('invoiceAssistantMobileAuthInfoAlipay');
  }else if (____isWechatBrowser()) {
    token = localStorage.getItem('invoiceAssistantMobileAuthInfoWechat');
  }else if (____isDingBrowser()) {
    token = localStorage.getItem('invoiceAssistantMobileAuthInfoDing');
  }else {
    token = localStorage.getItem('invoiceAssistantMobileAuthInfoOther');
  }
  if (token == 'undefined' || token == 'null') {
    token = null;
  }
  return token;
}
/**
 * 删除存储在 sessionStorage中的token
 * @returns
 */
export function clearToken() {
  if (____isAppH5Browser()) {
    localStorage.removeItem('invoiceAssistantMobileAuthInfoH5');
  } else if (____isAlipayBrowser()) {
    localStorage.removeItem('invoiceAssistantMobileAuthInfoAlipay');
  }else if (____isWechatBrowser()) {
    localStorage.removeItem('invoiceAssistantMobileAuthInfoWechat');
  } else if (____isDingBrowser()) {
    localStorage.removeItem('invoiceAssistantMobileAuthInfoDing');
  } else {
    localStorage.removeItem('invoiceAssistantMobileAuthInfoOther');
  }
}

/**
 * 设置用户自定义设置
 * @param {any} token
 */
export function setUserSetting(setting) {
  // localStorage.setItem('invoiceAssistantMobileUserSetting', setting);

  if (____isAppH5Browser()) {
    localStorage.setItem('invoiceAssistantMobileUserSettingH5', setting);
  }
  if (____isAlipayBrowser()) {
    localStorage.setItem('invoiceAssistantMobileUserSettingAlipay', setting);
  }
  if (____isWechatBrowser()) {
    localStorage.setItem('invoiceAssistantMobileUserSettingWechat', setting);
  }
  if (____isDingBrowser()) {
    localStorage.setItem('invoiceAssistantMobileUserSettingDing', setting);
  }
}
/**
 * 获取存储在 localStorage中的 用户自定义设置
 * @returns
 */
export function getUserSetting() {
  // return localStorage.getItem('invoiceAssistantMobileUserSetting');

  var setting = '';
  if (____isAppH5Browser()) {
    setting = localStorage.getItem('invoiceAssistantMobileUserSettingH5');
  }
  if (____isAlipayBrowser()) {
    setting = localStorage.getItem('invoiceAssistantMobileUserSettingAlipay');
  }
  if (____isWechatBrowser()) {
    setting = localStorage.getItem('invoiceAssistantMobileUserSettingWechat');
  }
  if (____isDingBrowser()) {
    setting = localStorage.getItem('invoiceAssistantMobileUserSettingDing');
  }
  return setting;
}
/**
 * 删除存储在 localStorage中的 用户自定义设置
 * @returns
 */
export function clearUserSetting() {
  // return localStorage.removeItem('invoiceAssistantMobileUserSetting');
  if (____isAppH5Browser()) {
    localStorage.removeItem('invoiceAssistantMobileUserSettingH5');
  }
  if (____isAlipayBrowser()) {
    localStorage.removeItem('invoiceAssistantMobileUserSettingAlipay');
  }
  if (____isWechatBrowser()) {
    localStorage.removeItem('invoiceAssistantMobileUserSettingWechat');
  }
  if (____isDingBrowser()) {
    localStorage.removeItem('invoiceAssistantMobileUserSettingDing');
  }
}

/**
 * 设置德邦BP报销岗（在这设置的原因是后台数据用户没有和BP相关的字段，前端需要存住这个用户的BP状态）
 * @param {any} type
 */
export function setDepponReimBurseType(type) {
  localStorage.setItem('depponReimBurseType', type);
}
/**
 * 获取存储在 localStorage中的depponReimBurseType设置
 * @returns
 */
export function getDepponReimBurseType() {
  return localStorage.getItem('depponReimBurseType');
}
/**
 * 删除存储在 localStorage中的depponReimBurseType设置
 * @returns
 */
export function clearDepponReimBurseType() {
  return localStorage.removeItem('depponReimBurseType');
}

export function clog($msg, $type) {
  var tm = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss');
  // var tm = new Date().format('yyyy-MM-dd hh:mm:ss');
  var type = $type || 'info';
  var str = tm + ' [' + type + ']:' + (typeof $msg == 'object' ? JSON.stringify($msg) : $msg);
  if (conf.debug) {
    if ($type == 'ERR') {
      console.log('%c' + str, 'color:#ff00ff;');
    } else {
      console.log('%c' + str, 'color:#0080ff;');
    }
  }
  return str;
}

/**
 * 将格式如 20180402115522  时间字符串 格式化
 * @param {*} dateStr   //YYYY-MM-DD HH:mm:ss
 */
export function formatDateTime2(dateStr, fmt) {
  if (dateStr == null || dateStr.length == 0) {
    return '';
  }
  // 2018 04 02 11 55 22
  var tempDate =
    '' +
    dateStr[0] +
    dateStr[1] +
    dateStr[2] +
    dateStr[3] +
    '/' + //年
    dateStr[4] +
    dateStr[5] +
    '/' + //月
    dateStr[6] +
    dateStr[7] +
    ' ' + //日
    dateStr[8] +
    dateStr[9] +
    ':' +
    dateStr[10] +
    dateStr[11] +
    ':' +
    dateStr[12] +
    dateStr[13] +
    '';
  var tm = dateFormat(new Date(tempDate), fmt || 'YYYY-MM-DD HH:mm:ss');
  return tm;
  // var tm = new Date().format('yyyy-MM-dd hh:mm:ss');
}
/**
 * 将格式如 20180402  日期字符串 格式化
 * @param {*} dateStr
 * @param {*} fmt   //YYYY-MM-DD HH:mm:ss
 */
export function formatDateTime3(dateStr, fmt) {
  if (dateStr == null || dateStr.length == 0) {
    return '';
  }
  // 2018 04 02 11 55 22
  var tempDate =
    '' +
    dateStr[0] +
    dateStr[1] +
    dateStr[2] +
    dateStr[3] +
    '/' + //年
    dateStr[4] +
    dateStr[5] +
    '/' + //月
    dateStr[6] +
    dateStr[7] +
    ' ' + //日
    '00:00:00';
  var tm = dateFormat(new Date(tempDate), fmt || 'YYYY-MM-DD HH:mm:ss');
  return tm;
  // var tm = new Date().format('yyyy-MM-dd hh:mm:ss');
}
/**
 * 将金额保留小数两位再转换为千分位
 * @param {*} num
 */
export function thousandBitSeparator(num) {
  if (isNaN(parseFloat(num))) {
    return '';
  }
  num = parseFloat(num).toFixed(2);
  return (
    num &&
    (num.toString().indexOf('.') != -1
      ? num.toString().replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
          return $1 + ',';
        })
      : num.toString().replace(/(\d)(?=(\d{3}))/g, function($0, $1) {
          return $1 + ',';
        }))
  );
}

/*对象深拷贝
 *create by yk 2016/5/19
 */

//util作为判断变量具体类型的辅助模块
var util = (function() {
  var class2type = {};
  ['Null', 'Undefined', 'Number', 'Boolean', 'String', 'Object', 'Function', 'Array', 'RegExp', 'Date'].forEach(
    function(item) {
      class2type['[object ' + item + ']'] = item.toLowerCase();
    }
  );

  function isType(obj, type) {
    return getType(obj) === type;
  }

  function getType(obj) {
    return class2type[Object.prototype.toString.call(obj)] || 'object';
  }
  return {
    isType: isType,
    getType: getType,
  };
})();
/**
 * 对象深copy  浅copy
 */
export function copyObject(obj, deep) {
  //如果obj不是对象，那么直接返回值就可以了
  if (obj === null || typeof obj !== 'object') {
    return obj;
  } //定义需要的局部变脸，根据obj的类型来调整target的类型
  var i,
    target = util.isType(obj, 'array') ? [] : {},
    value,
    valueType;
  for (i in obj) {
    value = obj[i];
    valueType = util.getType(value); //只有在明确执行深复制，并且当前的value是数组或对象的情况下才执行递归复制
    if (deep && (valueType === 'array' || valueType === 'object')) {
      target[i] = copyObject(value);
    } else {
      target[i] = value;
    }
  }
  return target;
}

/**
 * 获取客户端浏览器语言环境
 */
export function getBrowserLanguage() {
  return navigator.language || navigator.browserLanguage; //.toLowerCase()
}

/**
 * 微信授权地址  通过在微信请求一次
 */
export function getWxizedUrl(groupFlag, urlPath, param, appid3rd) {
  let appid = '';
  if (conf.api.wechat_appId != wechatAppid.xfp) {
    //非正式环境都通过票税助手商户版跳转页面
    groupFlag = 'STATE';
  }
  if (groupFlag === 'STATE') {
    appid = conf.api.wechat_appId;
    return (
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
      appid +
      '&redirect_uri=' +
      encodeURIComponent(conf.api.LOCATION_ORIGIN + urlPath) +
      '&response_type=code&scope=snsapi_base&state=STATE' +
      param +
      '#wechat_redirect'
    );
  } else {
    //appid为第三方公众号appid
    //appid = wechatAppid[groupFlag];
    return (window.location.href =
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
      appid3rd +
      '&redirect_uri=' +
      encodeURIComponent(conf.api.LOCATION_ORIGIN + urlPath) +
      '&response_type=code&scope=snsapi_base&state=' +
      groupFlag +
      param +
      '&component_appid=wx979a92f685ed9b2d#wechat_redirect');
  }
}

/**
 * 解析发票二维码内容
 *
 * 增值税普通发票 01,04,3300164320,30856012,318.10,20180508,11475938679360667598,865b,
 * 增值税专用发票 01,01,3100171130,09725707,3773.58,20170630,,EAB,
 * 增值税电子普通发票 01,10,031001700311,50756616,1203.77,20180404,11475938679360667598,5EFF,
 * 通行费增值税电子普通发票  01,10,011001700112,14280029,4.61,20180111,01916804770189053905,4F16,
 * 增值税普通发票(卷票) 01,11,3100173320,30856012,,,,865b,
 * 机动车销售统一发票  01,03,150001722060,00871843,118987.18,20180322,,CDA8,
 */
export function getVATQrcodeContent(val) {
  //当前年月
  var nowYear = new Date().getFullYear();
  // var nowYear2 = parseInt(nowYear[2] + nowYear[3]);
  if (val) {
    try {
      var arrVal = val.split(',');
      if (arrVal.length < 7) {
        return null;
      }

      if (arrVal[0] != '01') {
        return null;
      }
      //10位 或12位  数字   发票代码
      if (!(/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2]))) {
        return null;
      }

      //10位    发票代码
      if (/^\d{10}$/.test(arrVal[2])) {
        //10位长度发票代码第1-4位：
        //行政区划代码数字限制为：
        //1100-1599，2100-2399，3100-3799，4100-4699，5000-5499，6100-6599
        var one2four = parseInt(arrVal[2][0] + '' + arrVal[2][1] + arrVal[2][2] + arrVal[2][3]);
        // console.log('one2four:'+one2four);
        if (
          one2four < 1100 ||
          (one2four > 1599 && one2four < 2100) ||
          (one2four > 2399 && one2four < 3100) ||
          (one2four > 3799 && one2four < 4100) ||
          (one2four > 4699 && one2four < 5000) ||
          (one2four > 5499 && one2four < 6100) ||
          one2four > 6599
        ) {
          return null;
        }
        //第5-6位：年份数字限制为：01-17（当前年份）
        var fivesix = parseInt('20' + arrVal[2][4] + '' + arrVal[2][5]);
        // console.log('fivesix:'+fivesix);
        if (!(fivesix >= 2001 && fivesix <= nowYear)) {
          return null;
        }
        //第8位：发票类型数字限制为：1，2，3，5，6，7（
        //1，5--专票；
        //2，7--货物运输业增值税专用发票；
        //3，6--普票）
        if ([1, 2, 3, 5, 6, 7, '1', '2', '3', '5', '6', '7'].indexOf(arrVal[2][7]) == -1) {
          return null;
        }
      }

      //12位    发票代码
      if (/^\d{12}$/.test(arrVal[2])) {
        /*
        第1位数字限制：0，1当第1位为0且第11-12位为11时为增值税电子普通发票；
        当第1位为0且第11-12位为04或05增值税普通发票（折叠票）（04-两联；05-五联）;
        当第1位为0且第11-12位为06或07时为增值税普通发票（卷票）；
        当第1位为1且第8位为2时为机动车销售统一发票.
        当第11-12为17二手车销售统一发票
        当第11-12为26通栏式发票
        当第1位为0且第11-12为12通行费电子普通发票
        */
        if ([0, 1, '0', '1'].indexOf(arrVal[2][0]) == -1) {
          return null;
        }

        //第2-5位：行政区划代码数字限制为：
        //1100-1599，2100-2399，3100-3799，4100-4699，5000-5499，6100-6599
        var two2five = parseInt(arrVal[2][1] + '' + arrVal[2][2] + arrVal[2][3] + arrVal[2][4]);
        if (
          two2five < 1100 ||
          (two2five > 1599 && two2five < 2100) ||
          (two2five > 2399 && two2five < 3100) ||
          (two2five > 3799 && two2five < 4100) ||
          (two2five > 4699 && two2five < 5000) ||
          (two2five > 5499 && two2five < 6100) ||
          two2five > 6599
        ) {
          return null;
        }

        //第6-7位：年份数字限制为：01-17（当前年份） 当前使用50  表示2050年
        var sixsevern = parseInt('20' + arrVal[2][5] + '' + arrVal[2][6]);
        if (!(sixsevern >= 2001 && sixsevern <= nowYear)) {
          return null;
        }
      }

      //8位 数字  发票号码
      if (!/^\d{8}$/.test(arrVal[3])) {
        return null;
      }

      //增值税专用发票
      //01,01,3100171130,09725707,3773.58,20170630,,EAB,
      //抵扣联  01,01,3100171130,09725707,3773.58,20170630,EAB,
      if (
        arrVal[0] == '01' &&
        arrVal[1] == '01' &&
        //金额数字  数字或小数 不含税金额
        /^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) &&
        //是YYYYMMDD日期格式   发票日期
        /^\d{8}$/.test(arrVal[5]) &&
        regexpValid.toDateFromString(arrVal[5]) != null //&&
        //arrVal[6] == ''  抵扣联
      ) {
        //增值税专用发票
        return {
          documentType: '10001001',
          code: arrVal[2],
          no: arrVal[3],
          date: arrVal[5],
          totalAmount: arrVal[4],
          checkCode: '',
        };
      }

      //增值税普通发票（卷票）
      if (
        //01，04  表示增值税普通发票
        arrVal[0] == '01' &&
        arrVal[1] == '11' &&
        //10位 或12位  数字   发票代码
        (/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) &&
        //8位 数字  发票号码
        /^\d{8}$/.test(arrVal[3]) &&
        //金额数字  数字或小数 不含税金额
        arrVal[4] == '' &&
        //是YYYYMMDD日期格式   发票日期
        arrVal[5] == '' &&
        //是校验码   20位数字   校验码
        arrVal[6] == '' &&
        //是随机数
        arrVal[7] != ''
      ) {
        return {
          documentType: '40001001',
          code: arrVal[2],
          no: arrVal[3],
          date: arrVal[5],
          totalAmount: arrVal[4],
          checkCode: arrVal[6],
        };
      }

      //机动车销售统一发票
      //01，03 表示机动车销售统一发票
      //01,03,150001722060,00871843,118987.18,20180322,,CDA8,
      if (
        arrVal[0] == '01' &&
        arrVal[1] == '03' &&
        //10位 或12位  数字   发票代码
        (/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) &&
        //8位 数字  发票号码
        /^\d{8}$/.test(arrVal[3]) &&
        //金额数字  数字或小数 不含税金额
        /^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) &&
        //是YYYYMMDD日期格式   发票日期
        /^\d{8}$/.test(arrVal[5]) &&
        regexpValid.toDateFromString(arrVal[5]) != null
      ) {
        return {
          documentType: '50001001',
          code: arrVal[2],
          no: arrVal[3],
          date: arrVal[5],
          totalAmount: arrVal[4],
          checkCode: arrVal[6],
        };
      }

      //增值税电子普通发票
      //01，10  表示增值税电子普通发票
      //01,10,031001700311,50756616,1203.77,20180404,11475938679360667598,5EFF,
      if (
        arrVal[0] == '01' &&
        arrVal[1] == '10' &&
        //10位 或12位  数字   发票代码
        (/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) &&
        //8位 数字  发票号码
        /^\d{8}$/.test(arrVal[3]) &&
        //金额数字  数字或小数 不含税金额
        /^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) &&
        //是YYYYMMDD日期格式   发票日期
        /^\d{8}$/.test(arrVal[5]) &&
        regexpValid.toDateFromString(arrVal[5]) != null &&
        //是校验码   20位数字   校验码
        /^\d{20}$/.test(arrVal[6])
      ) {
        return {
          documentType: '30001001',
          code: arrVal[2],
          no: arrVal[3],
          date: arrVal[5],
          totalAmount: arrVal[4],
          checkCode: arrVal[6],
        };
      }

      //增值税普通发票
      //01，04  表示增值税普通发票
      //01,04,3300164320,30856012,318.10,20180508,11475938679360667598,865b,
      if (
        arrVal[0] == '01' &&
        arrVal[1] == '04' &&
        //10位 或12位  数字   发票代码
        (/^\d{10}$/.test(arrVal[2]) || /^\d{12}$/.test(arrVal[2])) &&
        //8位 数字  发票号码
        /^\d{8}$/.test(arrVal[3]) &&
        //金额数字  数字或小数 不含税金额
        /^[0-9]+(\.[0-9]+)?$/.test(arrVal[4]) &&
        //是YYYYMMDD日期格式   发票日期
        /^\d{8}$/.test(arrVal[5]) &&
        regexpValid.toDateFromString(arrVal[5]) != null &&
        //是校验码   20位数字   校验码
        /^\d{20}$/.test(arrVal[6])
      ) {
        return {
          documentType: '20001001',
          code: arrVal[2],
          no: arrVal[3],
          date: arrVal[5],
          totalAmount: arrVal[4],
          checkCode: arrVal[6],
        };
      }
      return null;
    } catch (error) {
      return null;
    }
  } else {
    return null;
  }
}

/*
 * 增值税普通发票 01,04,3300164320,30856012,318.10,20180508,11475938679360667598,865b,
 * 增值税专用发票 01,01,3100171130,09725707,3773.58,20170630,,EAB,
 * 增值税电子普通发票 01,10,031001700311,50756616,1203.77,20180404,11475938679360667598,5EFF,
 * 通行费增值税电子普通发票  01,10,011001700112,14280029,4.61,20180111,01916804770189053905,4F16,
 * 增值税普通发票(卷票) 01,11,3100173320,30856012,,,,865b,
 * 机动车销售统一发票  01,03,150001722060,00871843,118987.18,20180322,,CDA8,
 */
// console.log(getVATQrcodeContent('01,04,3300164320,30856012,318.10,20180508,11475938679360667598,865b,'));
// console.log(getVATQrcodeContent('01,01,3100171130,09725707,3773.58,20170630,,EAB,'));
// console.log(getVATQrcodeContent('01,10,031001700311,50756616,1203.77,20180404,11475938679360667598,5EFF,'));
// console.log(getVATQrcodeContent('01,10,011001700112,14280029,4.61,20180111,01916804770189053905,4F16,'));
// console.log(getVATQrcodeContent('01,11,3100173320,30856012,,,,865b,'));
// console.log(getVATQrcodeContent('01,03,150001722060,00871843,118987.18,20180322,,CDA8,'));
/**
 * 获取链接参数，参数可能分布在? #之间前后...
 */
export function getUrlKey(url, name) {
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ''])[1].replace(/\+/g, '%20')
    ) || null
  );
}
/**
 * 获取cookie
 */
export function getCookie(c_name) {
  if (document.cookie.length > 0) {
    let c_start = '';
    let c_end = '';
    c_start = document.cookie.indexOf(c_name + '=');
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      c_end = document.cookie.indexOf(';', c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return '';
}


export  function rTranslateDate(params) {
  if (params.paperDrewDate != '' && params.paperDrewDate != null) {
    params.paperDrewDate = params.paperDrewDate.replace(/-/g, '');
  }
  if (params.documentType == '50001011') {
    params.tInvoiceExtendObj.extend1 = params.tInvoiceExtendObj.extend1.replace(/-/g, '');
  } else if (params.documentType == '50001010') {
    params.tInvoiceExtendObj.extend4 = params.tInvoiceExtendObj.extend4.replace(/-/g, '');
  } else if (params.documentType == '50001009') {
    let tempDate = params.tInvoiceExtendObj.extend18;
    for (let d of tempDate) {
      d.date = d.date.replace(/-/g, '');
    }
    params.tInvoiceExtendObj.extend18 = tempDate;
    params.tInvoiceExtendObj.extend22 = params.tInvoiceExtendObj.extend22.replace(/-/g, '');
  } else if (params.documentType == '50001016') {
    params.tInvoiceExtendObj.extend7 = params.tInvoiceExtendObj.extend7.replace(/-/g, '');
  }else if(params.documentType == '50001014'){
    params.tInvoiceExtendObj.extend1 = params.tInvoiceExtendObj.extend1.replace(/-/g, '');
  }
  return params;
}

export function operateInvoice(invoice,operateType){
  if(invoice.discernFlag == discernStatus.discerning){
    tip('识别中',operateType)
    return false
  }else if(invoice.verifyFlag == String(invoiceCheckStatus.checking)){
    tip('验真中',operateType)
    return false
  }else if(invoice.processFlag == invoiceReimbursementStatus.reimbursementing){
    tip('报销中',operateType)
    return false
  }else if(invoice.processFlag == invoiceReimbursementStatus.reimbursement){
    tip('已报销的票',operateType)
    return false
  }else if(invoice.verifyFlag == invoiceCheckStatus.checkSuccess){
    if(operateType != 'del'){
      tip('验证成功的票',operateType)
      return false
    }else{
      return true
    }
  }else{
    return true
  }
}


export function tip(text,operateType){
  let operateText = operateType == 'edit' ? '编辑' : '删除'
  vue.$vux.toast.show({
    text: `${text}不允许${operateText}`,
    type: "text"
  });
}

export function isBlockChainInvoice(code){
  if(code.length == 12){
    let firstCode = code.substring(0,1)
    let endCode = code.substring(10,12)
    if(firstCode == '1' && endCode == '10'){
      return true
    }else{
      return false
    }
  }else{
    return false
  }
}


export function companySource() {
  return localStorage.getItem('source')
}
